<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('channelTest.label.payLine')" name="payLine">
        <el-card>
          <el-form :model="form" v-bind="bindForm">
            <el-form-item prop="merchantNo" :label="$t('channelTest.label.merchantNo')">
              <el-input v-model="form.merchantNo" v-if="this.info.userType === 0" />
              <div v-else class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ form.merchantNo }}
                </p>
              </div>
            </el-form-item>

            <el-form-item prop="type" :label="$t('channelTest.label.type')">
              <el-button
                :type="form.type === item ? 'primary' : ''"
                v-for="item in typeList"
                :key="item"
                @click="handleValue('type', item)"
              >
                {{ item }}
              </el-button>
            </el-form-item>

            <el-form-item prop="code" :label="$t('channelTest.label.code')">
              <el-button
                :type="form.code === item ? 'primary' : ''"
                v-for="item in codeList"
                :key="item"
                @click="handleValue('code', item)"
              >
                {{ item }}
              </el-button>
            </el-form-item>

            <el-form-item prop="amount" :label="$t('channelTest.label.amount')">
              <el-input v-model="form.amount"> </el-input>
            </el-form-item>

            <el-form-item prop="bankCode" :label="$t('device.bankCode')" v-if="form.type == 'payout'">
              <el-select v-model="form.bankCode" filterable clearable >
                <el-option v-for="item in bankCodeList" :key="item" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item  prop="bankCardNumber" :label="$t('device.bankAccount')" v-if="form.type == 'payout'">
              <el-input v-model="form.bankCardNumber" clearable > </el-input>
            </el-form-item>

            <el-form-item prop="username" :label="$t('channelTest.label.username')" v-if="form.type == 'payout'">
              <el-input v-model="form.username" clearable > </el-input>
            </el-form-item>


            <el-form-item prop="payType" label="Pay type" v-show="form.type == 'usdt_qr'">
              <el-select v-model="form.payType">
                <el-option value="1" label="USDT"></el-option>
                <el-option value="0" label="VND"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="rateType" label="Rate type" v-show="form.type == 'usdt_qr'">
              <el-select v-model="form.rateType">
                <el-option value="1" label="Real time"></el-option>
                <el-option value="0" label="Fixed"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="notifyUrl" :label="$t('channelTest.label.notifyUrl')">
              <el-input v-model="form.notifyUrl"> </el-input>
            </el-form-item>

            <el-form-item prop="merchantKey" :label="$t('merchantdetails.merchantkey')">
              <el-input v-model="form.merchantKey" v-if="this.info.userType === 0" />

              <div v-else class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ form.merchantKey }}
                </p>
              </div>
            </el-form-item>

            <el-form-item :label="$t('channelTest.label.params')">
              <div class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ sign }}
                </p>
              </div>
            </el-form-item>

            <el-form-item :label="$t('channelTest.label.sign')">
              <div class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ signKey }}
                </p>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button @click="handleTest()" style="width: 100%" type="primary">
                {{ $t('btns.confirm') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>
      <el-tab-pane :label="$t('channelTest.label.checkout')" name="checkout">
        <el-card>
          <el-form :model="checkoutForm" ref="ruleForm" v-bind="bindForm">
            <el-form-item prop="merchantNo" :label="$t('channelTest.label.merchantNo')">
              <el-input v-model="checkoutForm.merchantNo" v-if="this.info.userType === 0" />
              <div v-else class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ checkoutForm.merchantNo }}
                </p>
              </div>
            </el-form-item>

            <!--            <el-form-item prop="type" :label="$t('channelTest.label.type')">-->
            <!--              <el-button-->
            <!--                :type="checkoutForm.type === item ? 'primary' : ''"-->
            <!--                v-for="item in typeList"-->
            <!--                :key="item"-->
            <!--                @click="handleValue('type', item)">-->
            <!--                {{ item }}-->
            <!--              </el-button>-->
            <!--            </el-form-item>-->

            <!--            <el-form-item prop="code" :label="$t('channelTest.label.code')">-->
            <!--              <el-button-->
            <!--                :type="form.code === item ? 'primary' : ''"-->
            <!--                v-for="item in codeList"-->
            <!--                :key="item"-->
            <!--                @click="handleValue('code', item)"-->
            <!--              >-->
            <!--                {{ item }}-->
            <!--              </el-button>-->
            <!--            </el-form-item>-->

            <el-form-item prop="amount" :label="$t('channelTest.label.amount')">
              <el-input v-model="checkoutForm.amount"> </el-input>
            </el-form-item>

            <!--            <el-form-item prop="payType" label="Pay type" v-show="form.type == 'usdt_qr'">-->
            <!--              <el-select v-model="form.payType">-->
            <!--                <el-option value="1" label="USDT"></el-option>-->
            <!--                <el-option value="0" label="VND"></el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->

            <!--            <el-form-item prop="rateType" label="Rate type" v-show="form.type == 'usdt_qr'">-->
            <!--              <el-select v-model="form.rateType">-->
            <!--                <el-option value="1" label="Real time"></el-option>-->
            <!--                <el-option value="0" label="Fixed"></el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->

            <el-form-item prop="notifyUrl" :label="$t('channelTest.label.notifyUrl')">
              <el-input v-model="checkoutForm.notifyUrl"> </el-input>
            </el-form-item>

            <el-form-item prop="merchantKey" :label="$t('merchantdetails.merchantkey')">
              <el-input v-model="checkoutForm.merchantKey" v-if="this.info.userType === 0" />

              <div v-else class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ checkoutForm.merchantKey }}
                </p>
              </div>
            </el-form-item>

            <el-form-item :label="$t('channelTest.label.params')">
              <div class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ checkoutSign }}
                </p>
              </div>
            </el-form-item>

            <el-form-item :label="$t('channelTest.label.sign')">
              <div class="el-input el-input--small is-disabled">
                <p class="el-input__inner">
                  {{ signKey }}
                </p>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button @click="handleCheckoutTest" style="width: 100%" type="primary">
                {{ $t('btns.confirm') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import channelApi from '@/api/channel';
import orderApi from '@/api/orders';
import { random } from 'lodash';
import md5 from 'js-md5';
import { validInt, validHTTP } from '@/utils/validate';
export default {
  name: 'channelTest',
  data() {
    return {
      activeName: 'payLine',
      form: {
        amount: '',
        notifyUrl: 'https://user.xkiosx.xyz/trade/pay/test',
        merchantNo: '',
        merchantKey: '',
        code: '',
        type: '',
        selfMerchantNo: '',
        payType: '1',
        linkType: '2',
        rateType: '1',
        bankCode: '',//银行编码
        bankCardNumber: '',//银行卡号
        username: '',//用户名

      },
      checkoutForm: {
        amount: '',
        notifyUrl: 'https://user.xkiosx.xyz/trade/pay/test',
        merchantNo: '',
        properties: 'asiadev',
        sign: '',
        merchantKey: '',
        selfMerchantNo: ''
      },
      merchantData: [],
      types: {},
      bankCodeList:[],
    };
  },
  computed: {
    info() {
      return this.$store.state.user.info;
    },
    typeList() {
      return Object.keys(this.types);
    },
    codeList() {
      if (!this.form.type || this.form.type === 'card_pc') {
        return [];
      }
      return this.types[this.form.type].length ? this.types[this.form.type] : [];
    },
    sign() {
      const timestamp = parseInt(new Date().getTime() / 1000);
      const usdtSign = `${this.form.merchantNo}|${this.form.selfMerchantNo}|${this.form.amount}|${this.form.type}|${this.form.payType}|${this.form.linkType}|${this.form.rateType}|${timestamp}|${this.form.merchantKey}|`;
      const otherSign = `${this.form.merchantNo}|${this.form.selfMerchantNo}|${this.form.type}|${
        this.form.code === 'empty' ? '' : this.form.code
      }|${this.form.amount}|${timestamp}|${this.form.merchantKey}|`;
      const payoutSign =`${this.form.merchantNo}|${this.form.selfMerchantNo}|${this.form.bankCode}|${this.form.bankCardNumber}|${this.form.amount}|${timestamp}|${this.form.merchantKey}|`;
      const signMap = {
        usdt_qr: usdtSign,
        payout: payoutSign,
      };
      return signMap[this.form.type] || otherSign;
    },
    signKey() {
      return md5(this.sign);
    },
    checkoutSign() {
      const timestamp = parseInt(new Date().getTime() / 1000);
      // testMerchantNo+"|"+orderNo+"|"+data.amount+"|"+timestamp+"|"+testKey+"|";
      console.log(
        '获取到的sign数据是。。。',
        this.checkoutForm.merchantNo,
        this.checkoutForm.selfMerchantNo,
        this.checkoutForm.merchantKey
      );
      return `${this.checkoutForm.merchantNo}|${this.checkoutForm.selfMerchantNo}|${this.checkoutForm.amount}|${timestamp}|${this.checkoutForm.merchantKey}|`;
    }
  },

  created() {
    this.init();
    this.getBankCodeList();
  },

  methods: {
    init() {
      this.getType();
      this.getMerchantData();
      this.handleEmpty();
      this.bindForm = {
        ref: 'form',
        'label-width': 'auto',
        inline: false,
        size: 'small',
        rules: {
          amount: [
            {
              required: true,
              message: this.$t('channelTest.rules.amount.required'),
              trigger: 'blur'
            },
            {
              validator: (r, value, cb) => {
                if (!validInt(value)) {
                  cb(new Error(this.$t('channelTest.rules.amount.type')));
                } else {
                  cb();
                }
              },
              trigger: 'blur'
            }
          ],

          notifyUrl: [
            {
              required: true,
              message: this.$t('channelTest.rules.notifyUrl.required'),
              trigger: 'blur'
            },
            {
              validator: (r, value, cb) => {
                if (!validHTTP(value)) {
                  cb(new Error(this.$t('channelTest.rules.notifyUrl.format')));
                } else {
                  cb();
                }
              },
              trigger: 'blur'
            }
          ],
          type: [
            {
              required: true,
              message: this.$t('channelTest.rules.type.required'),
              trigger: 'blur'
            }
          ],
          getmerchantNo: [
            {
              required: true,
              message: this.$t('channelTest.rules.getmerchantNo.required'),
              trigger: 'submit'
            }
          ],
          selfMerchantNo: [
            {
              required: true,
              message: this.$t('channelTest.rules.selfMerchantNo.required'),
              trigger: 'submit'
            }
          ],
          merchantKey: [
            {
              required: true,
              message: this.$t('channelTest.rules.merchantKey.required'),
              trigger: 'blur'
            }
          ],
          code: [
            {
              message: this.$t('channelTest.rules.code.required'),
              trigger: 'blur'
            }
          ],
          merchantNo: [
            {
              required: true,
              message: this.$t('channelTest.rules.merchantNo.required'),
              trigger: 'blur'
            }
          ],
          bankCode: [
            {
              required: true,
              message: this.$t('channelTest.rules.bankCode.required'),
              trigger: 'blur'
            }
          ],
          bankCardNumber: [
            {
              required: true,
              message: this.$t('channelTest.rules.bankCardNumber.required'),
              trigger: 'blur'
            }
          ],

        }
      };
    },
    handleEmpty() {
      // const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/;

      let notifyUrl = '',
        merchantNo = '',
        merchantKey = '';
      if (+this.info.userType === 0) {
        // merchantNo = /(asia2|test|localhost)/g.test(window.location.host) || reg.test(window.location.host) ? 'test4848460801' : 'kece8810460161';
        // merchantKey = /(asia2|test|localhost)/g.test(window.location.host) || reg.test(window.location.host) ? 'XV039N9mgrOEo0540840L625ru341R20' : 'Q1J3t603P2492R52wt3i68L0zJ15706a';
        merchantNo = 'test4848460801';
        merchantKey = 'XV039N9mgrOEo0540840L625ru341R20';
        notifyUrl = 'https://user.xkiosx.xyz/trade/pay/test';
        // /(test|localhost)/g.test(window.location.host) || reg.test(window.location.host)
        //   ? 'https://bo-test.yldyd.xyz/api/merchant/orderStatus/callback'
        //   : 'https://bo-asia.smxjoiai.xyz/api/merchant/orderStatus/callback';
      } else {
        merchantNo = this.info.userName;
        merchantKey = this.info.merchantKey;
      }
      this.form = {
        selfMerchantNo: '',
        amount: '',
        notifyUrl,
        merchantNo,
        merchantKey,
        code: '',
        type: '',
        payType: '1',
        linkType: '2',
        rateType: '1'
      };
      this.checkoutForm = {
        selfMerchantNo: '',
        amount: '',
        notifyUrl,
        merchantNo,
        merchantKey,
        properties: 'asiadev'
      };
    },
    handleValue(k, v) {
      this.form[k] = v;
      if (this.codeList.length === 0) {
        this.form.code = 'empty';
      }
    },
    getmerchantNo() {
      this.form.selfMerchantNo =
        Date.now().toString() +
        random(10000000, 99999999, false).toString() +
        Number(new Date().getFullYear()).toString() +
        Number(new Date().getMonth()).toString().padStart(2, 0);
    },
    async getMerchantData() {
      const { data } = await orderApi.getMerchantData({ data: {} });
      if (data) {
        if (data.code == 200) {
          this.merchantData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    async getType() {
      const { data } = await channelApi.confType();
      if (data) {
        if (data.code == 200) {
          this.types = data.data;
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    handleTest() {
      this.getmerchantNo();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const timestamp = parseInt(new Date().getTime() / 1000);
          const code = this.form.code === '' || this.form.code == 'empty' ? '' : this.form.code;
          const params = {
            ...Object.keys(this.form).reduce((acc, key) => {
              if (this.form[key] && key !== 'selfMerchantNo') {
                acc[key] = this.form[key];
              }
              return acc;
            }, {}),
            merchantNo: this.info.userType !== 0 ? this.info.userName : this.form.merchantNo,
            code,
            outTradeNo: this.form.selfMerchantNo,
            timestamp: timestamp,
            sign: md5(this.sign)
          };
          console.log(this.sign);
          const { data } = await channelApi.doTest(params);
          if (data) {
            if (data.success) {
              this.$message.success(data.data);
               //解决navigator.clipboard复制 在正式环境报错
              if(navigator.clipboard && window.isSecureContext) {
                navigator.clipboard
                .writeText(data.data)
                .then(() => {
                   this.$message.success(this.$t('channelTest.copy'));
                })
                .catch(() => {
                   this.$message.error(this.$t('status.error'));
                })
               } else {
                      let textArea = document.createElement("textarea");
                      textArea.value = data.data;
                      textArea.style.position = "absolute";
                      textArea.style.opacity = 0;
                      textArea.style.left = "-999999px";
                      textArea.style.top = "-999999px";
                      document.body.appendChild(textArea);
                      textArea.focus();
                      textArea.select();
                      return new Promise((resolve,reject) => {
                        //执行复制命令并移除文本框
                        document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
                        textArea.remove()
                      }).then (
                         () => {
                          this.$message.success(this.$t('channelTest.copy'));
                        },
                          () => {
                          this.$message.error(this.$t('status.error'));
                          }
                      )
               }


              // navigator.clipboard
              //   .writeText(data.data)
              //   .then(() => {
              //     this.$message.success(this.$t('channelTest.copy'));
              //   })
              //   .catch(() => {
              //     this.$message.error(this.$t('status.error'));
              //   });
            } else {
              this.$message.error(data.message);
            }
          }
        }
      });
    },

    handleCheckoutTest() {
      this.checkoutForm.selfMerchantNo =
        Date.now().toString() +
        random(10000000, 99999999, false).toString() +
        Number(new Date().getFullYear()).toString() +
        Number(new Date().getMonth()).toString().padStart(2, 0);
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const timestamp = parseInt(new Date().getTime() / 1000);
          // const code = this.form.code === '' || this.form.code == 'empty' ? '' : this.form.code;
          const params = {
            ...Object.keys(this.checkoutForm).reduce((acc, key) => {
              if (this.checkoutForm[key] && key !== 'selfMerchantNo') {
                acc[key] = this.checkoutForm[key];
              }
              return acc;
            }, {}),
            merchantNo:
              this.info.userType !== 0 ? this.info.userName : this.checkoutForm.merchantNo,
            outTradeNo: this.checkoutForm.selfMerchantNo,
            timestamp: timestamp,
            sign: md5(this.checkoutSign)
          };
          console.log(this.checkoutSign);
          const { data } = await channelApi.doCheckTest(params);
          if (data) {
            if (data.success) {
              // this.$message.success(data.data);
              setTimeout(() => {
                window.open(data.data, '_blank');
              }, 1000);
              // navigator.clipboard.writeText(data.data).then(() => {
              //   this.$message.success(this.$t('channelTest.copy'))
              // }).catch(()=>{
              //   this.$message.error(this.$t('status.error'))
              // })
            } else {
              this.$message.error(data.message);
            }
          }
        }
      });
    },

     //payout bankCode
     async getBankCodeList() {
      const { data } = await channelApi.bankCodeList();
      if (data) {
        if (data.code == 200) {
           const bankCodes = data.data.map(item => {
            return item.bankCode
          });
          this.bankCodeList = [...new Set(bankCodes)];
        } else {
          this.$message.error(data.msg);
        }
      }
    },

  }
};
</script>

<style lang="scss">
.msgbox {
  width: 666px;
}
</style>



// WEBPACK FOOTER //
// src/components/channel-test/index.vue